// extracted by mini-css-extract-plugin
export default {"empty-list":"Wishlist_empty-list__qB7EV"};